import Vue from 'vue'

class RegiaoService {
  async busca(uf, cidade, credenciado, redes) {
    try {
      let params = redes.map(rede => "redes[]=" + rede).join("&");
      const response = await Vue.prototype.$http.get(
        `regioes/${uf}?modelo=m&cidade=${cidade || ""}&${params ||""}&credenciado=${credenciado || ""}`
      )
      return await response.data
    } catch (error) {
      throw error
    }
  }
}

export default new RegiaoService();
